(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moah-best-sellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initMoahCardSlider(slider) {
      if (slider.dataset.moahCardSliderReady === 'true') return;

      const track = slider.querySelector('[data-moah-card-track]');
      if (!track) return;

      const cards = Array.from(track.children);
      if (cards.length === 0) return;

      slider.dataset.moahCardSliderReady = 'true';
      let index = 0;
      let timer = null;
      let pointerStartX = 0;
      let pointerStartScroll = 0;
      let isPointerDown = false;
      let hasDragged = false;
      const delay = Number(slider.dataset.interval) || 3500;
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      function cardsPerStep() {
        const count = mobileQuery.matches ? slider.dataset.mobileCardCount : slider.dataset.desktopCardCount;
        return Math.max(1, Number(count) || 1);
      }

      function setActive(nextIndex) {
        index = nextIndex;
        const card = cards[index];
        const offset = card ? card.offsetLeft : 0;
        slider.scrollTo({ left: offset, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }

      function next() {
        const step = cardsPerStep();
        const nextIndex = index + step >= cards.length ? 0 : index + step;
        setActive(nextIndex);
      }

      function start() {
        if (reducedMotion.matches || cards.length <= cardsPerStep() || timer) return;
        timer = window.setInterval(next, delay);
      }

      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      function handlePointerDown(event) {
        if (event.button !== 0) return;
        isPointerDown = true;
        hasDragged = false;
        pointerStartX = event.clientX;
        pointerStartScroll = slider.scrollLeft;
        slider.classList.add('is-dragging');
        slider.setPointerCapture(event.pointerId);
        stop();
      }

      function handlePointerMove(event) {
        if (!isPointerDown) return;
        const distance = event.clientX - pointerStartX;
        if (Math.abs(distance) > 4) hasDragged = true;
        slider.scrollLeft = pointerStartScroll - distance;
      }

      function handlePointerEnd(event) {
        if (!isPointerDown) return;
        isPointerDown = false;
        slider.classList.remove('is-dragging');
        if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
        start();
      }

      function handleClick(event) {
        if (!hasDragged) return;
        event.preventDefault();
        event.stopPropagation();
        hasDragged = false;
      }

      slider.addEventListener('pointerdown', handlePointerDown);
      slider.addEventListener('pointermove', handlePointerMove);
      slider.addEventListener('pointerup', handlePointerEnd);
      slider.addEventListener('pointercancel', handlePointerEnd);
      slider.addEventListener('click', handleClick, true);
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      window.addEventListener('resize', () => setActive(index));
      mobileQuery.addEventListener('change', () => setActive(index));
      reducedMotion.addEventListener('change', () => {
        stop();
        start();
      });

      setActive(0);
      start();
    }

    function initAllMoahCardSliders(root = document) {
      root.querySelectorAll('[data-moah-card-slider]').forEach(initMoahCardSlider);
    }

    document.addEventListener('DOMContentLoaded', () => initAllMoahCardSliders());
    document.addEventListener('shopify:section:load', (event) => initAllMoahCardSliders(event.target));
    initAllMoahCardSliders();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moah-collection-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initMoahCardSlider(slider) {
      if (slider.dataset.moahCardSliderReady === 'true') return;

      const track = slider.querySelector('[data-moah-card-track]');
      if (!track) return;

      const cards = Array.from(track.children);
      if (cards.length === 0) return;

      slider.dataset.moahCardSliderReady = 'true';
      let index = 0;
      let timer = null;
      let pointerStartX = 0;
      let pointerStartScroll = 0;
      let isPointerDown = false;
      let hasDragged = false;
      const delay = Number(slider.dataset.interval) || 3500;
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      function cardsPerStep() {
        const count = mobileQuery.matches ? slider.dataset.mobileCardCount : slider.dataset.desktopCardCount;
        return Math.max(1, Number(count) || 1);
      }

      function setActive(nextIndex) {
        index = nextIndex;
        const card = cards[index];
        const offset = card ? card.offsetLeft : 0;
        slider.scrollTo({ left: offset, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }

      function next() {
        const step = cardsPerStep();
        const nextIndex = index + step >= cards.length ? 0 : index + step;
        setActive(nextIndex);
      }

      function start() {
        if (reducedMotion.matches || cards.length <= cardsPerStep() || timer) return;
        timer = window.setInterval(next, delay);
      }

      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      function handlePointerDown(event) {
        if (event.button !== 0) return;
        isPointerDown = true;
        hasDragged = false;
        pointerStartX = event.clientX;
        pointerStartScroll = slider.scrollLeft;
        slider.classList.add('is-dragging');
        slider.setPointerCapture(event.pointerId);
        stop();
      }

      function handlePointerMove(event) {
        if (!isPointerDown) return;
        const distance = event.clientX - pointerStartX;
        if (Math.abs(distance) > 4) hasDragged = true;
        slider.scrollLeft = pointerStartScroll - distance;
      }

      function handlePointerEnd(event) {
        if (!isPointerDown) return;
        isPointerDown = false;
        slider.classList.remove('is-dragging');
        if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
        start();
      }

      function handleClick(event) {
        if (!hasDragged) return;
        event.preventDefault();
        event.stopPropagation();
        hasDragged = false;
      }

      slider.addEventListener('pointerdown', handlePointerDown);
      slider.addEventListener('pointermove', handlePointerMove);
      slider.addEventListener('pointerup', handlePointerEnd);
      slider.addEventListener('pointercancel', handlePointerEnd);
      slider.addEventListener('click', handleClick, true);
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      window.addEventListener('resize', () => setActive(index));
      mobileQuery.addEventListener('change', () => setActive(index));
      reducedMotion.addEventListener('change', () => {
        stop();
        start();
      });

      setActive(0);
      start();
    }

    function initAllMoahCardSliders(root = document) {
      root.querySelectorAll('[data-moah-card-slider]').forEach(initMoahCardSlider);
    }

    document.addEventListener('DOMContentLoaded', () => initAllMoahCardSliders());
    document.addEventListener('shopify:section:load', (event) => initAllMoahCardSliders(event.target));
    initAllMoahCardSliders();
  })();

  } catch(e) { console.error(e); }
})();
})();
